module.exports = __webpack_public_path__ + "static/media/inside_view_back_2.5d09753b.jpg";